import React from 'react'
import { getLocalData } from '../../../services/StorageServices'
import CombineShipRow from './CombineShipTable/CombineShipRow'
import CombineShipHead from './CombineShipTable/CombineShipHead'

function CombineShipTable(props) {
    const { listCombineShip, loading, reload, selectAll, onCheckALl, arrSelected, onSelected, onGetInfoBox} = props
    const userRoles = !!getLocalData('roles') && getLocalData('roles').length > 0 ? getLocalData('roles').map(i => i.name) : []
    const batchShipPermissions = !!getLocalData('user') && getLocalData('user').batch_ship

    return (
        <div className='BatchShipTable'>
            <div className="wrapTable">
                <table className='table mb-4'>
                    <CombineShipHead />
                    <tbody>
                        {
                            !!listCombineShip && listCombineShip.map((item, i) => {
                                return <CombineShipRow
                                    key={item._id}
                                    index={i}
                                    item={item}
                                    reload={reload}
                                    userRoles={userRoles}
                                    batchShipPermissions={batchShipPermissions}
                                    arrSelected={arrSelected}
                                    onSelected={onSelected}
                                    onGetInfoBox={onGetInfoBox}
                                />
                            })
                        }
                        {
                            !loading && listCombineShip.length === 0 &&
                            <tr>
                                <td colSpan={9}>
                                    No result
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>

            
        </div>
    )
}

export default CombineShipTable